import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-177d6984"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["href"]

import { computed, useSlots } from "vue";
import { mapValues } from "lodash";
import { isExternal, isAbsolute } from "@/util/url";
import { stringify } from "@/util/object";

interface Props {
  /** location to link to */
  to: string;
  /**
   * state data to attach on navigation. object/array values get stringified.
   * https://developer.mozilla.org/en-US/docs/Web/API/History/pushState
   */
  state?: Record<string, unknown>;
  /** whether to forcibly forgo external icon when link is external */
  noIcon?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLink',
  props: {
    to: null,
    state: { default: undefined },
    noIcon: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { to: string, state: Record<string, unknown>, noIcon: boolean }



const slots = useSlots();

/** is "to" prop an external url */
const externalLink = computed(() => isExternal(props.to));

/** is "to" prop an absolute url */
const absoluteLink = computed(() => isAbsolute(props.to));

/** is provided slot just plain text */
const plainText = computed(
  () =>
    slots.default &&
    slots.default().length === 1 &&
    typeof slots.default()[0].children === "string"
);

/**
 * convert "to" prop to separate route props because vue-router can't do this
 * itself
 */
const splitTo = computed(() => {
  const [, path, hash] = props.to.match(/([^#]*)(#[^#]*)?/) || [];
  return { path, hash };
});

return (_ctx: any,_cache: any) => {
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (!__props.to)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ]))
    : (_unref(absoluteLink))
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: __props.to,
          target: "_blank"
        }, [
          (_unref(externalLink) && _unref(plainText) && !__props.noIcon)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("span", null, [
                  _renderSlot(_ctx.$slots, "default")
                ]),
                _createVNode(_component_AppIcon, {
                  class: "icon",
                  icon: "external-link-alt"
                })
              ], 64))
            : _renderSlot(_ctx.$slots, "default", { key: 1 })
        ], 8, _hoisted_2))
      : (_openBlock(), _createBlock(_component_router_link, {
          key: 2,
          to: {
      ..._unref(splitTo),
      state: _unref(mapValues)(__props.state, (value) => _unref(stringify)(value)),
    },
          replace: !!_unref(splitTo).hash && !_unref(splitTo).path
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 8, ["to", "replace"]))
}
}

})